import { ICohortRow } from '../../../redux/slices/oldBuilder';
import {
  IMeasureFieldsFragment,
  MeasureType,
} from '../../apollo/graphqlSchema';
import { parseSimpleMeasure } from './utils';

/**
 * A function will parse Simple or Compound measure reference for
 * measure cohort condition. References are always collapsed by default
 */
export const parseMeasureToCohortRow = (
  measure: IMeasureFieldsFragment,
): Partial<ICohortRow> => {
  if (measure.__typename === 'SimpleMeasure') {
    const parsedMeasure = parseSimpleMeasure(measure, null);

    // In case of simple named measure we will show collapsed view.
    // However, because user is able to Expand it, we have to parse measure
    // and add it to result
    if (measure?.version?.versionId) {
      return {
        ...parsedMeasure,
        isCollapsedMeasure: true,
      };
    }

    return parsedMeasure;
  }

  return {
    type: MeasureType.Compound,
    measureId: measure?.version?.versionId ?? '',
    isCollapsedMeasure: true,
    showMeasure: true,
    defaultNamedMeasure: measure,
  };
};
